<template>
  <v-container id="vromo" tag="section">
    <base-v-component heading="Sincronización reparto VROMO " />
    <!-- CENTRALIZADO -->
    <base-material-card color="indigo" icon="mdi-bike" inline class="px-5 py-3">
      <v-toolbar flat color="white"> </v-toolbar>

      <v-tabs
        v-model="tab"
        background-color="deep-purple accent-4"
        center-active
        dark
      >
        <v-tab>Sites</v-tab>
        <v-tab>Jobs</v-tab>
        <v-tab>Vehicles</v-tab>
        <v-tab>Hooks</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="0">
          <v-card color="basil" flat>
            <v-card-title>Restaurantes</v-card-title>
            <v-card-text>
              <v-list>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    v-for="rest in restaurantes"
                    :key="rest.id"
                  >
                    <v-list-item>
                      <v-list-item-action>
                        <v-icon v-if="rest.vromoId" color="green"
                          >mdi-check</v-icon
                        >
                        <v-icon v-else color="red">mdi-close</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        {{ rest.nombre }}
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          class="primary"
                          small
                          v-if="!rest.vromoId"
                          @click="crearSite(rest)"
                          :loading="cargando == rest.id"
                        >
                          Crear site
                        </v-btn>
                        <v-btn
                          class="info"
                          small
                          v-else
                          @click="actualizarSite(rest)"
                          :loading="cargando == rest.id"
                        >
                          Actualizar site
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="1"> </v-tab-item>
        <v-tab-item key="2"> </v-tab-item>
        <v-tab-item key="3">
          <v-card color="basil" flat>
            <v-card-title>Hooks</v-card-title>
            <v-card-text>
              <v-list>
                <v-row>
                  <v-btn
                    class="primary"
                    :disabled="hooks.length > 0"
                    @click="crearHook()"
                    :loading="loadingHook"
                    >Crear Hook</v-btn
                  > </v-row
                ><v-row>
                  <v-col cols="12" v-for="h in hooks" :key="h.id">
                    <v-list-item>
                      <v-list-item-action>
                        <v-icon color="green">mdi-check</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        {{ h.target }}
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          class="primary"
                          small
                          @click="deleteHook(h)"
                          :loading="loadingHook"
                        >
                          Eliminar hook
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      tab: 0,
      cargando: null,
      loadingHook: false,
      hooks: [],
    };
  },
  computed: {
    restaurantes() {
      return this.$store.state.restaurantes.restaurantesArray;
    },
  },
  watch: {
    tab(v) {
      if (v == 3) {
        this.getHooks();
      }
    },
  },
  methods: {
    getRestaurantes() {
      this.$store.dispatch("restaurantes/getRestaurantes");
    },
    crearHook() {
      this.loadingHook = true;
      this.$store
        .dispatch("vromo/createHook", this.$store.state.app.negocioGest)
        .then((res) => {
          if (!res.ok) return Promise.reject(res.error);
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Hook creado con éxito",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al crear el hook: " + error,
          });
        })
        .finally(() => {
          this.loadingHook = false;
        });
    },
    getHooks() {
      this.loadingHook = true;
      this.$store
        .dispatch("vromo/getHooks", this.$store.state.app.negocioGest)
        .then((res) => {
          if (!res.ok) return Promise.reject(res.error);
          this.hooks = res.datos;
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Hook recuperados con éxito",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al recuperar los hooks: " + error,
          });
        })
        .finally(() => {
          this.loadingHook = false;
        });
    },
    deleteHook(item) {
      this.loadingHook = true;
      this.$store
        .dispatch("vromo/deleteHook", {
          idnegocio: this.$store.state.app.negocioGest,
          idhook: item.id,
        })
        .then((res) => {
          if (!res.ok) return Promise.reject(res.error);
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Hook eliminado con éxito",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al eliminar el hooks: " + error,
          });
        })
        .finally(() => {
          this.loadingHook = false;
          this.getHooks();
        });
    },
    crearSite(item) {
      this.cargando = item.id;
      this.$store
        .dispatch("restaurantes/crearSiteVromo", item.id)
        .then((res) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Site creado con éxito",
          });
          return this.getRestaurantes();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al crear el site: " + error,
          });
        })
        .finally(() => {
          this.cargando = null;
        });
    },
    actualizarSite(item) {
      this.cargando = item.id;
      this.$store
        .dispatch("restaurantes/actualizarSiteVromo", item.id)
        .then((res) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Site actualizado con éxito",
          });
          return this.getRestaurantes();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el site: " + error,
          });
        })
        .finally(() => {
          this.cargando = null;
        });
    },
  },
};
</script>

<style>
</style>